import router from '@/modules/emailsHistory/router'

export default {
  router,
}
